import { getCart } from '../shared/api/shared-app-requests';
import { cleanupAssociatedProductData } from '../shared/utils/cart';
import { REGISTERED_APPS } from '../shared/types/Apps';
import { cleanupInvalidDiscountData } from '../shared/utils/discounts';

async function cleanupCartData(runningAppName: REGISTERED_APPS) {
  const cart = await getCart();

  if (cart) {
    await cleanupInvalidDiscountData(cart, runningAppName);
    cleanupAssociatedProductData(cart, runningAppName);
  }
}

export default cleanupCartData;
